module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-68.ff3bca9.woff2";